import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=3450350f&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&lang=less&"
import style1 from "./invite.vue?vue&type=style&index=1&id=3450350f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450350f",
  null
  
)

export default component.exports